import React from 'react'
import { View, TouchableOpacity, StyleSheet } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '../atoms/text'
import { Theme } from '@theme'
import { useLanguage } from '@context'

export const GenderSwitch = ({ isSmall = false, gender, onGenderSelect }: { isSmall: boolean, gender?: "male" | "female" | "non-binary", onGenderSelect: (gender: "male" | "female" | "non-binary") => void }) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyles(theme, isSmall)

  return (
    <View style={styles.genderContainer}>
        <TouchableOpacity
            style={[
            styles.genderButton,
            gender === 'female' && styles.genderButtonSelected
            ]}
            onPress={() => onGenderSelect('female')}
        >
            <Text
            type={isSmall ? 'bodyExtraSmall' : 'body'}
            color={gender === 'female' ? theme.colors.white : theme.colors.text}
            >
            {isSmall ? t('filters.genderFemale') : t('filters.genderFemaleLong')}
            </Text>
        </TouchableOpacity>
        <TouchableOpacity
            style={[
            styles.genderButton,
            gender === 'male' && styles.genderButtonSelected
            ]}
            onPress={() => onGenderSelect('male')}
        >
            <Text
            type={isSmall ? 'bodyExtraSmall' : 'body'}
            color={gender === 'male' ? theme.colors.white : theme.colors.text}
            >
            {isSmall ? t('filters.genderMale') : t('filters.genderMaleLong')}
            </Text>
        </TouchableOpacity>
        <TouchableOpacity
            style={[
            styles.genderButton,
            gender === 'non-binary' && styles.genderButtonSelected
            ]}
            onPress={() => onGenderSelect('non-binary')}
        >
            <Text
            type={isSmall ? 'bodyExtraSmall' : 'body'}
            color={gender === 'non-binary' ? theme.colors.white : theme.colors.text}
            >
            {isSmall ? t('filters.genderNonBinary') : t('filters.genderNonBinaryLong')}
            </Text>
        </TouchableOpacity>
    </View>
  )
}

const getStyles = (theme: Theme, isSmall: boolean) =>
    StyleSheet.create({
        genderContainer: {
            flex: 1,
            flexDirection: 'row',
            marginVertical: isSmall? 0 : theme.spacing.lg,
            borderRadius: isSmall ? 20 : 50,
            backgroundColor: '#F5F5F5',
            padding: isSmall ? 2 : 4,
            height: isSmall ? undefined : 56,
        },
        genderButton: {
            flex: 1,
            padding: isSmall ? theme.spacing.xs : theme.spacing.sm,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: isSmall ? 20 : 50,
        },
        genderButtonSelected: {
            backgroundColor: theme.colors.primary,
        },
    })